<template>
  <div class="space-y-6">
     <div class="text-center space-y-2">
      <h1 class="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Business Details</h1>
      <p class="text-slate-500 dark:text-slate-400">Let's set up your {{ role === 'operator' ? 'dive operation' : 'business' }}.</p>
    </div>

    <form @submit.prevent="handleSubmit" class="space-y-4">
      <TextInput
        v-model="formData.name"
        :label="'Shop/Business Name'"
        placeholder="Paradise Divers"
      />

      <TextInput
        v-model="formData.website"
        @blur="formatWebsiteUrl"
        label="Website"
        placeholder="https://paradisedivers.com"
        helper-text="Standard URL format required: https://website.com"
      />

      <div class="space-y-1">
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300">Location</label>
        <!-- Using the wrapper component for Geocoding -->
         <MapboxGeocoderInput 
           v-model="formData.location"
           placeholder="Search City or Region (e.g. Bali)"
           @select="handleLocationSelect"
         />
      </div>

      <div class="flex gap-3 pt-2">
          <Button 
            v-if="showBack"
            variant="outline"
            size="lg"
            @click="$emit('back')"
          >
            Back
          </Button>
          
          <Button 
            type="submit" 
            variant="primary"
            size="lg"
            class="flex-1"
            :disabled="!canProceed"
          >
            Continue
          </Button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { reactive, computed, watch } from 'vue'
import MapboxGeocoderInput from '../signup/MapboxGeocoderInput.vue'
import Button from '../shared/Button.vue'
import TextInput from '../shared/TextInput.vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ role: 'operator', name: '', website: '', location: '', coordinates: null, bbox: null })
  },
  showBack: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['submit', 'back', 'update'])

const formData = reactive({ ...props.initialData })
const role = computed(() => formData.role || 'operator')

// Sync internal state if prop updates
watch(() => props.initialData, (newVal) => {
    Object.assign(formData, newVal)
}, { deep: true })

const canProceed = computed(() => {
  return formData.name && formData.location && formData.coordinates
})

const formatWebsiteUrl = () => {
    let url = formData.website?.trim();
    if (url && !/^https?:\/\//i.test(url)) {
        formData.website = 'https://' + url;
    }
}

const handleLocationSelect = (data) => {
     formData.coordinates = data.center
     formData.bbox = data.bbox
     formData.location = data.place_name
     // Emit partial update if parent wants live data
     emit('update', { ...formData })
}

const handleSubmit = () => {
    if (!canProceed.value) return
    emit('submit', { ...formData })
}
</script>
